import { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

let navigator: NavigateFunction | null = null;

export const setNavigator = (navigate: NavigateFunction) => {
  navigator = navigate;
};

export const clearNavigator = () => {
  navigator = null;
};

export const navigateByService = (to: To, options?: NavigateOptions): boolean => {
  if (!navigator) {
    return false;
  }

  navigator(to, options);
  return true;
};
